import { useContext } from 'react'
import { FeatureFlagContext } from '@/contexts/FeatureFlagContext'
import type { FeatureFlags } from '@/types/featureFlags'
import type { LabsFlagInfo } from '@/services/featureFlagsService'

export interface UseFeatureFlagsResult {
    flags: FeatureFlags
    isAdmin: boolean
    isLoading: boolean
    labsFlags: LabsFlagInfo[]
}

export function useFeatureFlags(): UseFeatureFlagsResult {
    const context = useContext(FeatureFlagContext)
    if (context === undefined) {
        throw new Error('useFeatureFlags must be used within a FeatureFlagProvider')
    }
    return context
}
